import { useEffect, useRef } from 'react';
import DCFMarkdown from '../DCFMarkdown/DCFMarkdown';
import Header from '../Header/Header';
import Footer from '../form/Footer';

type Props = {
  children: React.ReactNode;
  title?: string;
  subTitle?: string;
  fullWidth?: boolean;
};

function PublicPageTemplate({ children, title, subTitle, fullWidth = false }: Props) {
  const titleRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    titleRef.current?.focus();
  }, [title]);

  return (
    <>
      <a href="#main-content" className="govuk-skip-link" data-module="govuk-skip-link">
        Skip to main content
      </a>
      <Header loading={false} />
      <div className="govuk-width-container">
        <main className="govuk-main-wrapper" id="main-content">
          <div className="govuk-grid-row">
            <div className={fullWidth ? 'govuk-grid-column-full' : 'govuk-grid-column-two-thirds'}>
              {title && (
                <h1 className="govuk-heading-xl" ref={titleRef} tabIndex={-1}>
                  {subTitle && <DCFMarkdown content={subTitle} type="subtitle" />}
                  {title}
                </h1>
              )}
              {children}
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </>
  );
}

export default PublicPageTemplate;
